export default __webpack_public_path__ + "static/media/personal-new-more-icon.1a72de2b.svg";